import { SET_NOTIFICATIONS, ADD_NOTIFICATION, MARK_NOTIFICATIONS_AS_READ } from '../mutation-types';

import markNotificationsAsReadService from 'services/account/markNotifications';
import Vue from 'vue';

import liveDiscussionService from 'services/liveDiscussion';

import { EventBus } from 'utils/event-bus';

export const setNotifications = ({ commit }, notifications) => {
  commit(SET_NOTIFICATIONS, notifications);
};

export const addNotification = ({ commit }, notification) => {
  const toast_message = notification.description;
  if (notification.event === 'LD_feedback_given') {
    liveDiscussionService
      .loadLiveDiscussion(notification.live_discussion_id)
      .then(({ data }) => {
        if (data.is_ended) {
          const toast = {
            type: 'Info',
            message: toast_message,
            time: 5000,
            notification: notification
          };
          EventBus.$emit('createToast', toast);
          commit(ADD_NOTIFICATION, notification);
        }
      });
  } else {
    const toast = {
      type: 'Info',
      message: toast_message,
      time: 5000,
      notification: notification
    };
    EventBus.$emit('createToast', toast);
    commit(ADD_NOTIFICATION, notification);
  }
};

export const markNotificationsAsRead = ({ commit }, notificationIDs) => {
  // notificationIDs has to be array of notification ids
  markNotificationsAsReadService(notificationIDs)
    .then((resp) => {
      if (resp.status === 204) {
        commit(MARK_NOTIFICATIONS_AS_READ, notificationIDs);
      }
    })
    .catch(console.error);
};

export const navigateFromNotification = ({ dispatch }, notification) => {
  const { live_discussion_id, roundtable_id, event } = notification;
  if (roundtable_id) {
    dispatch('navigateFromOnlineRoundtableNotification', notification);
  } else if (live_discussion_id) {
    dispatch('navigateFromLiveDiscussionNotification', notification);
  } else if (event === 'Course_CoTeacher_Invite') {
    dispatch('navigateToCourseFromNotification', notification);
  }
  dispatch('markNotificationsAsRead', [notification.id]);
};

export const navigateToCourseFromNotification = (context, notification) => {
  const route = { name: 'course.index', params: { courseID: notification.meta.course_id } };
  return Vue.router.push(route);
};

export const navigateFromOnlineRoundtableNotification = (context, notification) => {
  const { event, meta, roundtable_id, submission_id, recap_id, comment_id } = notification;
  const route = {
    name: 'roundtable.index',
    params: {
      courseID: meta.course_id,
      roundtableID: roundtable_id,
    },
    query: {
      submissionID: submission_id,
      recapID: recap_id,
      replyCommentID: meta.original_comment_id ? comment_id : null,
      topLevelCommentID: meta.original_comment_id || comment_id,
    },
    replace: true,
  };
  const routeInvite = {
    name: 'roundtable.index',
    params: {
      courseID: meta.course_id,
      roundtableID: roundtable_id,
    },
  };
  const routeStartFollowUp = {
    name: 'roundtable.index',
    params: {
      courseID: meta.course_id,
      roundtableID: roundtable_id,
    },
    query: {
      follow_up: true,
    },
    replace: true,
  };
  switch (event) {
    case 'RT_invite':
      return Vue.router.push(routeInvite);
    case 'RT_feedback_given':
      if (Vue.router.currentRoute.name === 'roundtable.prompt' || Vue.router.currentRoute.name === 'roundtable.summary') {
        const tab = 'discussion';
        EventBus.$emit('handleTab', tab);
        route.query.assessment = true;
        return Vue.router.push(route);
      }
      route.name = 'roundtable.discussion';
      route.query.assessment = true;
      return Vue.router.push(route);
    case 'RT_submission_comment':
    case 'RT_comment_reply':
    case 'RT_comment_flagged':
    case 'RT_submission_flagged':
    case 'RT_model_submission_selected':
      if (Vue.router.currentRoute.name === 'roundtable.prompt' || Vue.router.currentRoute.name === 'roundtable.summary') {
        const tab = 'discussion';
        EventBus.$emit('handleTab', tab);
        return Vue.router.push(route);
      }
      route.name = 'roundtable.discussion';
      return Vue.router.push(route);
    case 'RT_start_follow_up':
      return Vue.router.push(routeStartFollowUp);
    default:
      return Vue.router.push(route);
  }
};

// navigateFromLiveDiscussionNotification
export const navigateFromLiveDiscussionNotification = (
  context,
  notification
) => {
  const { meta, live_discussion_id } = notification;
  const route = {
    name: 'live-discussion.discussion',
    params: {
      courseID: meta.course_id,
      liveDiscussionID: live_discussion_id,
    },
  };
  const routeStartFollowUp = {
    name: 'live-discussion.discussion',
    params: {
      courseID: meta.course_id,
      liveDiscussionID: live_discussion_id,
    },
    query: {
      follow_up: true,
    },
    replace: true,
  };
  const is_feedback = notification.event === 'LD_feedback_given';
  if (is_feedback) {
    route.query = {
      from_feedback: true,
    };
  } else if (notification.event === 'LD_start_follow_up') {
    return Vue.router.push(routeStartFollowUp);
  }
  Vue.router.push(route);
};



// WEBPACK FOOTER //
// ./src/app/store/actions/notifications.js